"use client";
import { el } from "date-fns/locale";
import styles from "./search.module.scss";
import { generateTitle } from "@/src/util/util";

const SearchBanner = ({ searchParams }) => {
  const { category_service_name, province_name, district_name, ward_name } = searchParams;

  const title = generateTitle({
    categoryServiceName: category_service_name?.toLowerCase(),
    provinceName: province_name,
    districtName: district_name,
    wardName: ward_name,
  });

  return (
    <>
      <div className={styles.searchBanner}>
        <div className={styles.mainBanner}>
          <h1>{title}</h1>
          <span>
            Cung cấp địa chỉ nha khoa uy tín gần nhất cho bạn từ danh sách
            5.000+ cơ sở nha khoa trên toàn quốc.
          </span>
        </div>
      </div>
    </>
  );
};

export default SearchBanner;
